import unionBy from 'lodash/unionBy';
import { rejected, resolved } from 'store/createAction';
import {
  DELETE_CONTACT,
  REMOVE_FROM_GROUP,
} from 'store/modules/contacts/types';
import { GET_GROUP_MEMBERS, REMOVE_MEMBERS } from '../types';

const initialState = {
  loading: false,
};

const groupReducer = (state = initialState, action) => {
  const { type, payload, meta } = action;
  switch (type) {
    case GET_GROUP_MEMBERS:
      return {
        ...state,
        loading: true,
      };
    case resolved(GET_GROUP_MEMBERS): {
      const group = state[meta.id];
      const members = group ? group.data : [];
      return {
        ...state,
        loading: false,
        [meta.id]: {
          data:
            meta.query.offset === 0
              ? payload
              : unionBy(members, payload, 'contact_hash'),
          hasMore:
            payload.length > 0 ? payload.length === meta.query.limit : false,
          ...meta.query,
        },
      };
    }
    case rejected(GET_GROUP_MEMBERS): {
      return {
        ...state,
        loading: false,
      };
    }
    case resolved(REMOVE_FROM_GROUP): {
      const group = state[meta.groupHash];
      if (group) {
        const members = group.data || [];
        return {
          ...state,
          [meta.groupHash]: {
            ...group,
            data: members.filter((i) => i.contact_hash !== meta.contactHash),
          },
        };
      }
      return state;
    }
    case resolved(REMOVE_MEMBERS): {
      const group = state[meta.groupHash];
      if (group) {
        const members = group.data || [];
        return {
          ...state,
          [meta.groupHash]: {
            ...group,
            data: members.filter(
              (i) => !meta.membersHash.includes(i.contact_hash),
            ),
          },
        };
      }
      return state;
    }
    case resolved(DELETE_CONTACT): {
      const newState = {};
      Object.keys(state).forEach((id) => {
        if (id !== 'loading') {
          const members = state[id].data;
          if (members) {
            newState[id] = {
              ...state[id],
              data: members.filter((contact) => contact.hash !== meta.id),
            };
          }
        }
      });
      return {
        ...state,
        ...newState,
      };
    }
    default:
      return state;
  }
};

export default groupReducer;
